import { render } from "./Instruction.vue?vue&type=template&id=2f4ae846"
import script from "./Instruction.vue?vue&type=script&lang=js"
export * from "./Instruction.vue?vue&type=script&lang=js"

import "./Instruction.vue?vue&type=style&index=0&id=2f4ae846&lang=css"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__